import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ButtonHTMLAttributes, useEffect, useState } from 'react';
import { Tooltip } from '../ui';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'success' | 'warning' | 'danger' | 'light' | 'secondary';
    block?: boolean;
    small?: boolean;
    isLoading?: boolean;
    loadingMessage?: string | React.JSX.Element | null;
    tooltip?: string;
    tooltipPlacement?: 'top' | 'bottom' | 'right' | 'left';
    icon?: IconDefinition;
}

export const Button = ({
    children,
    isLoading = false,
    loadingMessage,
    variant = 'success',
    small = false,
    block = false,
    icon,
    className,
    tooltip,
    tooltipPlacement = 'left',
    onClick,
    ...props
}: ButtonProps) => {
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        setShowTooltip(false);
    }, [props.disabled, isLoading]);

    return (
        <Tooltip
            tooltip={tooltip}
            show={showTooltip && tooltip !== undefined}
            onShow={setShowTooltip}
            placement={tooltipPlacement}
        >
            <button
                {...props}
                disabled={isLoading || props.disabled}
                className={`btn btn-${variant}${block ? 'btn-block' : ' '}${small ? 'btn-sm' : ''}${
                    className ? ' ' + className : ''
                }`}
                onClick={(e) => {
                    setShowTooltip(false);
                    if (onClick) onClick(e);
                }}
            >
                {isLoading ? (
                    <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        {loadingMessage && <span className="ml-2">{loadingMessage}</span>}
                    </>
                ) : icon ? (
                    <FontAwesomeIcon icon={icon} />
                ) : (
                    children
                )}
            </button>
        </Tooltip>
    );
};
